export default __webpack_public_path__ + "static/media/il-technologicoNC.a9382413.svg";